module.exports = __webpack_public_path__ + "media/PAG65-06.eb60871c.mp3";